import { defineStore } from "pinia";
import { ref, computed } from "vue";
import type { IUser } from "@/types/interfaces/IUser";
import { IS_DEMO } from "@/utils/env";

/** Hardcoded mock user used in demo mode. */
const MOCK_CURRENT_USER: IUser = {
  id: "mock-user-001",
  name: "Demo User",
  email: "demo@example.com",
};

export const useAuthStore = defineStore("auth", () => {
  // In demo mode the mock user is set immediately; in production mode the
  // user is null until Okta authentication completes.
  const currentUser = ref<IUser | null>(IS_DEMO ? MOCK_CURRENT_USER : null);

  const isAuthenticated = computed(() => currentUser.value !== null);
  const userId = computed(() => currentUser.value?.id ?? "");
  const userName = computed(() => currentUser.value?.name ?? "");

  /** Populate the store after a successful Okta authentication. */
  function setUser(user: IUser): void {
    currentUser.value = user;
  }

  /** Clear the store on sign-out. */
  function clearUser(): void {
    currentUser.value = null;
  }

  return { currentUser, isAuthenticated, userId, userName, setUser, clearUser };
});
